module.exports = __webpack_public_path__ + "img/3.372f5122.jpg";